<template>
  <div>
    <!-- <mz-screen-size></mz-screen-size> -->
    <div id="main-header" class="row">
      <div class="col d-flex">
        <span id="header-title" class="h3">
          <fa-icon :icon=icon /> {{ title }}
        </span>
      </div>
      <div class="col text-right">
        <router-link to="/">
          <img id="brand-logo" class="" src="@/assets/logo_ci_liebherr.svg" alt="logo liebherr">
        </router-link>
      </div>
    </div>
    <mz-page-header></mz-page-header>
  </div>
</template>

<script>
import PageHeader from '@/components/layout/PageHeader'
import ScreenSize from '@/components/debug/ScreenSize'

export default {
  name: 'mainHeader',
  data () {
    return {
      icon: 'comment-alt-exclamation',
      title: 'Give my Feedback'
    }
  },
  components: {
    mzPageHeader: PageHeader,
    mzScreenSize: ScreenSize
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/layout/Header.vue